export default "__VITE_ASSET__6b5e2db1__"